import { inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { WA_LOCATION } from '@ng-web-apis/common';
import { filter, first, map, Observable } from 'rxjs';

import { sponsorshipStore } from '../store/sponsorship.store';

export const SponsorshipResolver = (): Observable<boolean> => {
  const store = inject(sponsorshipStore);
  const location = inject<Location>(WA_LOCATION);

  const code = new URL(location.href).searchParams.get('code') ?? '';
  const token = new URL(location.href).searchParams.get('token') ?? '';

  store.fetchSponsorshipAndSponsor(code, token);

  return toObservable(store.sponsorshipLoadingStatus).pipe(
    filter((status) => !status.isLoading),
    first(),
    map((status) => {
      if (status.error) {
        return false;
      }
      return true;
    }),
  );
};
